import * as React from 'react'

import { AttendanceSidepanelCompensationBlockFragment } from 'generated/resources/graphql'

import CompensationOverview from 'modules/attendance/components/ClockIn/TabsBreakdown/CompensationPannel/Overview'

interface CompensationTabProps {
  employeeId: number
  setSelectedCompensationBlocks: React.Dispatch<
    React.SetStateAction<AttendanceSidepanelCompensationBlockFragment[]>
  >
}

export const CompensationTab = ({
  employeeId,
  setSelectedCompensationBlocks,
}: CompensationTabProps) => {
  return (
    <CompensationOverview
      setSelectedCompensationBlocks={setSelectedCompensationBlocks}
      employeeId={employeeId}
    />
  )
}
